import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import ImageUploadInput from "../../../../../../_shared/components/FormItems/ImageUploadInput"

// ----------------------------------------------------------------------------

function _ImageForm(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { values, onUpload } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleUpload(key) {
        return (e) => onUpload && onUpload(key, e)
    }

    function getThumbnail() {
        if (values?.url) {
            return typeof values.url === "string"
                ? values.url
                : URL.createObjectURL(values.url)
        }
    }

    function getDetail() {
        if (values?.detailUrl) {
            return typeof values.detailUrl === "string"
                ? values.detailUrl
                : URL.createObjectURL(values.detailUrl)
        }
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={props.className}>
            <h3>Thumbnail</h3>
            <div className="divider"></div>
            <ImageUploadInput
                onUpload={handleUpload("url")}
                image={getThumbnail()}
            />
            <h3>Immagine dettaglio</h3>
            <div className="divider"></div>
            <ImageUploadInput
                onUpload={handleUpload("detailUrl")}
                image={getDetail()}
            />
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_ImageForm.propTypes = {
    className: PropTypes.string.isRequired,
    values: PropTypes.object,
    onUpload: PropTypes.func,
}

_ImageForm.defaultProps = {}

// ----------------------------------------------------------------------------

const ImageForm = styled(_ImageForm)`
    & {
        h3 {
            font-family: "Poppins-Bold";
            margin-top: 30px;
            margin-bottom: 10px;
        }
        .divider {
            width: 250px;
            height: 1px;
            background: ${({ theme }) => theme.colors.dividerColor};
            margin-bottom: 20px;
        }
    }
`
// ----------------------------------------------------------------------------

export default ImageForm
